import axios from "axios";
import { getAuth } from "firebase/auth";
import { getRefs } from "../ref";
import { TYPES } from "./default_paper.type";
import { onSnapshot, query, limit, where, orderBy } from "firebase/firestore";
import { getApp } from "firebase/app";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { getApiFunctions } from "store/bailiff/api";
//func

const app = getApp();
const auth = getAuth(app);
const storage = getStorage(app);
// ========= firebase function =========//

//snap all provider
const allDefaultPaperSub = [];
export const snapLastPaper = (callback) => (dispatch) => {
  setDefaultPaperLastSuccess(dispatch, "none");
  const cRef = getRefs().paper;
  const uid = auth?.currentUser?.uid;
  const c1 = where("client", "==", uid);
  const c2 = orderBy("createAt", "desc");
  const c3 = limit(1);
  const qRef = query(cRef, c1, c2, c3);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      console.log({ paperData: data });
      const detail = data.length > 0 ? data[0] : null;
      setDefaultPaperLastSuccess(dispatch, detail);
      if (callback) {
        callback();
      }
    }
  });
  allDefaultPaperSub.push(unsub);
};

export const unSnapLastPaper = () => (dispatch) => {
  allDefaultPaperSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultPaperSub.length = 0;
};
// ========= cloud function =========//

// ========= storage function =========//
export const uploadBase64 =
  ({ file, fileName }, callback) =>
  async (dispatch) => {
    // reset before snap.

    ///

    // get signed url.
    const responseUrl = await getSignedUrl({ fileName });
    const signedUrl = responseUrl?.data?.url;
    console.log({ signedUrl });
    if (!signedUrl) {
      callback &&
        callback({ status: 500, data: "Invalid Request! Please try again!" });
      return;
    }

    try {
      const response = await axios.put(signedUrl, file, {
        headers: {
          "Content-Type": file.type || "audio/mpeg",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 1),
          );
          callback && callback({ status: 100, data: percentCompleted });
        },
      });

      console.log({ response });
      callback && callback({ status: 200 });
    } catch (error) {
      console.error("Upload failed", error);
      callback &&
        callback({ status: 500, data: error?.message || "Please try again!" });
    }
  };

// // lấy signed url.
const getSignedUrl = async ({ fileName }) => {
  const functions = getApiFunctions().client.clientUploadPaper;
  const options = { fileName };
  return functions(options)
    .then((signedUrl) => {
      console.log({ signedUrl });
      return signedUrl;
    })
    .catch((err) => {
      console.log({ err });
      return null;
    });
};
//
export const getPapperKycUrl = ({ fileName }, callback) => {
  const uid = auth?.currentUser?.uid;
  const path = `paper/kyc/${uid}/${fileName}`;
  const storageRef = ref(storage, path);
  getDownloadURL(storageRef)
    .then((url) => {
      callback && callback(url);
    })
    .catch((err) => {
      console.log({ err });
      callback && callback(null);
    });
};
// ========= local function =========//
export const setDefaultPaperAll = (data, callback) => (dispatch) => {
  setDefaultPaperAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultPaperOpenAdd = (data, callback) => (dispatch) => {
  setDefaultPaperOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultPaperOpenEdit = (data, callback) => (dispatch) => {
  setDefaultPaperOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultPaperSelected = (data, callback) => (dispatch) => {
  setDefaultPaperSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultPaperSearch = (data, callback) => (dispatch) => {
  setDefaultPaperSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDefaultPaperAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_ALL,
    payload: data,
  });
};

const setDefaultPaperOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_OPEN_ADD,
    payload: data,
  });
};

const setDefaultPaperOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_OPEN_EDIT,
    payload: data,
  });
};

const setDefaultPaperSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_SELECTED,
    payload: data,
  });
};

const setDefaultPaperSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_SEARCH,
    payload: data,
  });
};

const setDefaultPaperLastSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_PAPER_LAST,
    payload: data,
  });
};
